import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './Root';
import "./translate/i18n"

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Root />
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then(() => console.log("SW registered"))
    .catch(console.error);
}

